import Typography from "@mui/material/Typography";
import { Link } from "react-router";

import { SmallArrow } from "../../assets/icons";

import styles from "./NoAccess.module.scss";

const NoAccess = () => {
  return (
    <>
      <Typography variant="h1" color="primary.main">
        No Access Assigned
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        No modules are enabled for this user. Please contact your
        administrator for access.
      </Typography>
      <Link to="/profile" className={styles.link}>
        <SmallArrow className={styles.smallArrow} color="#002c8b" />
        Go to profile
      </Link>
    </>
  );
};

export default NoAccess;
